import moment from "moment";
import { FAILURE, GET, POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function obtenerListaProgressBar(obj, combo = false, tag) {
    try {
        let data = [];
        const { code, body } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/progress-bar/obtener-lista-progress-bar",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data = body;
            if (combo === false) {
                for (let i = 0; i < data.length; i++) {
                    data[i].fechaProceso = moment(data[i].fechaProceso).format("YYYY/MM/DD HH:mm");
                    data[i].habilitadoLabel = data[i].habilitado === 1 ? tag("column_habilitado") : tag("column_deshabilitado");
                }
            }
            if (combo === true) {
                data = data.map((item) => {
                    return {
                        value: item.id,
                        label: item.codigo + " - " + item.descripcion,
                    };
                });
            }
        }
        return data;
    } catch (err) {
        console.log("obtenerListaProgressBar err");
        console.log(err);
        return [];
    }
}

export async function crearProgressBar(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/progress-bar/crear-progress-bar",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("crearProgressBar err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function actualizarProgressBar(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/progress-bar/actualizar-progress-bar",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("actualizarProgressBar err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function deshabilitarProgressBar(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/progress-bar/deshabilitar-progress-bar",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("deshabilitarProgressBar err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function habilitarProgressBar(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/progress-bar/habilitar-progress-bar",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("habilitarProgressBar err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function obtenerProgressBar() {
    try {
        let data = null;
        const { code, body } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/progress-bar/obtener-progress-bar",
            {
                headers: getHeaders(),
                method: GET,
                // body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data = body;
        }
        return data;
    } catch (err) {
        console.log("obtenerProgressBar err");
        console.log(err);
        return null;
    }
}